// step-1 form
export const STEP_1_FIELDS = new Set([
  'startDate', 'endDate', 'startTime',
  'tripType', 'categories',
]);

// Anclas de foco/aria de los campos compuestos del paso 1, en orden DOM
// (deben coincidir con los id de los templates de date/trip-types/interests-field)
export const PLANNER_A11Y_ANCHOR_IDS = {
  dates: 'planner-date-field',
  tripTypes: 'planner-trip-types-field',
  interests: 'planner-interests-field',
} as const;
// Códigos CLDR/ISO 3166-1 alpha-2 (Places API New los valida): es=España, pt=Portugal, ad=Andorra, br=Brasil
export const SUPPORTED_COUNTRIES_STAY = ['es', 'pt', 'ad', 'br'];

// step-2 form
export const NON_STEP_FIELDS = new Set([
  'startLocationAddress', 'startLocationLat', 'startLocationLng', 'subdomain',
]);
export const TYPE_OF_REGISTER_MODULAR_FORM_FIELD = {
  country: 'country', 
  province: 'province',
  cp: 'cp',
  selection_multiple: 'selection_multi',
  selection_unique: 'selection_unique',
  text: 'text',
} as const;

// Google Maps Places API type filter for countries
export const AUTOCOMPLETE_TYPES_COUNTRY = ['country'];
export const SUPPORTED_COUNTRIES_ALL: string[] = [];
export const SEARCH_RADIUS_KM_GLOBAL = 180;
export const STRICT_BOUNDS_GLOBAL = false;

// Google Maps Places API type filter for provinces
export const AUTOCOMPLETE_TYPES_PROVINCE = ['administrative_area_level_2'];
export const SUPPORTED_COUNTRIES_PROVINCE = ['es'];

export const SEARCH_RADIUS_KM_PROVINCE = 10;
export const STRICT_BOUNDS_PROVINCE = false;
